<template>
    <div>
        <div class="row data-form">
            <div class="col-12">
                <div class="border px-5 pt-5 pb-2 mb-4 rounded">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <b-form-group :label="$t('student_number')">
                                {{ formObj.student_number }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-4">
                            <b-form-group :label="$t('name_surname')">
                                {{ formObj.name + ' ' + formObj.surname }}
                            </b-form-group>
                        </div>
                        <div class="col-12 col-md-4">
                            <b-form-group :label="$t('program')">
                                {{ formObj.program_name }}
                            </b-form-group>
                        </div>
                    </div>
                    <template v-if="detailData">
                        <hr class="mt-0">
                        <div class="row">
                            <div class="col-12 col-md-4" v-if="detailData.delivery_type">
                                <b-form-group :label="$t('delivery_type')">{{ detailData.delivery_type }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.pickup_type">
                                <b-form-group :label="$t('pickup_type')">{{ detailData.pickup_type }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.pickup_person_name">
                                <b-form-group :label="$t('pickup_person_name')">{{ detailData.pickup_person_name }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.shipping_type">
                                <b-form-group :label="$t('shipping_type')">{{ detailData.shipping_type }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.recipient_full_name">
                                <b-form-group :label="$t('recipient_full_name')">{{ detailData.recipient_full_name }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.street_address">
                                <b-form-group :label="$t('street_address')">{{ detailData.street_address }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.apartment_suite">
                                <b-form-group :label="$t('apartment_suite')">{{ detailData.apartment_suite }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.delivery_city">
                                <b-form-group :label="$t('delivery_city')">{{ detailData.delivery_city }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.state_province_region">
                                <b-form-group :label="$t('state_province_region')">{{ detailData.state_province_region }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.zip_postal_code">
                                <b-form-group :label="$t('zip_postal_code')">{{ detailData.zip_postal_code }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.delivery_country_name">
                                <b-form-group :label="$t('delivery_country')">{{ detailData.delivery_country_name }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.delivery_phone">
                                <b-form-group :label="$t('delivery_phone')">{{ detailData.delivery_phone }}</b-form-group>
                            </div>
                            <div class="col-12 col-md-4" v-if="detailData.tracking_number">
                                <b-form-group :label="$t('tracking_number')">{{ detailData.tracking_number }}</b-form-group>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="documentRequests"
            :fields="documentRequestFields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded">
            <template #cell(buttons)="row">
                <b-dropdown variant="link btn-sm" boundary="window" no-caret>
                    <template #button-content>
                        <i class="ri-more-fill"></i>
                    </template>
                    <div id="dropdownListHead">
                      <b-dropdown-item @click="updateStatusFormShow(row.item)" v-if="checkPermission('documentrequest_updatestatus')">
                        <i class="ri-file-transfer-line align-middle top-minus-1 mr-3 text-muted"></i> {{$t('status_update')}}
                      </b-dropdown-item>
                    </div>
                </b-dropdown>
            </template>
        </b-table>
      <CommonModal ref="updateStatusFormModal" size="md" :onHideOnlyX="true">
        <template v-slot:CommonModalTitle>
          {{ $t('status_update').toUpper() }}
        </template>
        <template v-slot:CommonModalContent>
          <update-status-form :id="requestId" :currentStatus="currentStatus" @hide="updateStatusFormSuccess" />
        </template>
      </CommonModal>
      <CommonModal ref="uploadTranscriptFormModal" size="md" :onHideOnlyX="true">
        <template v-slot:CommonModalTitle>
          {{ $t('upload_scanned_transcript').toUpper() }}
        </template>
        <template v-slot:CommonModalContent>
          <upload-transcript-form :id="requestId" @hide="uploadTranscriptFormSuccess" />
        </template>
      </CommonModal>
    </div>
</template>

<script>
// Services
import DocumentRequestService from "@/services/DocumentRequestService";

// Other
import AppLayout from "@/layouts/AppLayout"
import CommonModal from "@/components/elements/CommonModal";
import UpdateStatusForm from "./UpdateStatusForm";
import UploadTranscriptForm from "./UploadTranscriptForm";

export default {
    components: {
        AppLayout,
        CommonModal,
        UpdateStatusForm,
        UploadTranscriptForm,
    },
    props: {
        formObj: {
            type: Object,
        }
    },
    data() {
        return {
            requestId: 0,
            currentStatus: null,
            documentRequests: [],
            detailData: null,
            documentRequestFields: [
                {
                    key: 'buttons',
                    label: '',
                    thClass: 'width-50'
                },
                {
                    key: 'document_type_name',
                    label: this.$t('document_type'),
                },
                {
                    key: 'date',
                    label: this.$t('date').toUpper(),
                },
                {
                    key: 'requested_count',
                    label: this.$t('requested_count'),
                },
                {
                    key: 'status_name',
                    label: this.$t('status'),
                },
                {
                    key: 'id',
                    label: '',
                    thClass: 'd-none',
                    tdClass: 'd-none'
                },
            ],
        }
    },
    watch: {
        formObj: function () {
            this.get()
        }
    },
    created() {
        this.get()
    },
    methods: {
        get() {
            DocumentRequestService.getById(this.formObj.id).then(response => {
                const data = response.data.data;
                this.documentRequests = [data];
                this.detailData = data;
            }).catch(() => {})
        },

        updateStatusFormShow(obj) {
            this.requestId = obj.id
            this.currentStatus = obj.status
            this.$refs.updateStatusFormModal.$refs.commonModal.show()
        },
        updateStatusFormSuccess() {
            this.$refs.updateStatusFormModal.$refs.commonModal.hide()
            this.get()
        },
        uploadTranscriptFormShow(obj) {
            this.requestId = obj.id
            this.$refs.uploadTranscriptFormModal.$refs.commonModal.show()
        },
        uploadTranscriptFormSuccess() {
            this.$refs.uploadTranscriptFormModal.$refs.commonModal.hide()
            this.get()
        },


    },


}
</script>
